import { Component, Input, OnInit } from '@angular/core';
import { Loading } from './loading';

@Component({
  selector: 'app-base-loader',
  templateUrl: './base-loader.component.html',
  styleUrls: ['./base-loader.component.scss'],
})
export class BaseLoaderComponent implements OnInit {
  @Input() loader = false;

  constructor(private loading: Loading) {}

  ngOnInit(): void {
    this.loading.isLoading.subscribe((value) => {
      this.loader = value;
    });
  }
}
